import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import './assets/css/reset.css';
import './assets/scss/fonts.scss';
import './assets/scss/main.scss';

import '@/helpers/index';
import './plugins/element-io';
import {
  i18n
} from './plugins/vuei8n';

Vue.config.productionTip = false;

import VueTelInput from 'vue-tel-input';
Vue.use(VueTelInput);

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate);

window.$router = router;

Vue.prototype.$log = (event) => {
  amplitude.getInstance("hilfy").logEvent(event)
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');